<script setup lang="ts">
import ChatGPT from './@components/Icons/ChatGPT/index.vue'
import SnackPrompt from './@components/Icons/SnackPrompt/index.vue'
import Gemini from './@components/Icons/Gemini/index.vue'
import Claude from './@components/Icons/Claude/index.vue'
import Midjourney from './@components/Icons/Midjourney/index.vue'

const { colors } = useTheme()
</script>

<template>
  <section w-full flex="~ col" justify-center items-center mb-50px>
    <Heading level="5-light" :color="colors.darkerGray">
      Fully Compatible With
    </Heading>

    <div flex flex-wrap mt-16px items-center justify-center space-x="40px <sm:20px">
      <ChatGPT mb-15px />

      <SnackPrompt mb-15px />

      <Gemini mb-15px />

      <Midjourney mb-15px />

      <Claude mb-15px />
    </div>
  </section>
</template>
